import * as Yup from 'yup';
import { errorMessages, errorMessagesRegistration } from '~/constants/errorMessages.ts';
import { blockedDomains } from '~/constants/common.ts';
import { regularExpressions } from '~/constants/regularExpressions.ts';

export const passwordValidationSchema = Yup.string()
  .required(errorMessages.FIELD_REQUIRED)
  .min(8, errorMessagesRegistration.MIN_LENGTH_PASSWORD)
  .matches(/[A-Z]/, errorMessagesRegistration.PASSWORD_UPPERCASE)
  .matches(/[a-z]/, errorMessagesRegistration.PASSWORD_LOWERCASE)
  .matches(/[0-9]/, errorMessagesRegistration.PASSWORD_DIGITS)
  .matches(/[^A-Za-z0-9]/, errorMessagesRegistration.PASSWORD_SPECIAL_CHARS)
  .test('no-trivial-patterns', errorMessagesRegistration.PASSWORD_TRIVIAL_PATTERNS, (value) => {
    if (!value) return true;
    return !regularExpressions.TRIVIAL_PATTERNS.some((pattern) => pattern.test(value));
  })
  .test('no-invisible-spaces', errorMessagesRegistration.PASSWORD_INVISIBLE_SPACES, (value) => {
    if (!value) return true;
    return !regularExpressions.INVISIBLE_SPACE_REGEX.test(value);
  });

export const signUpValidationSchema = Yup.object().shape({
  checkConsentToDataProcessing: Yup.boolean().nullable(),
  username: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .test(
      'username-length',
      errorMessagesRegistration.MAX_LENGTH_LOGIN,
      (value) => !value || value.length <= 20
    )
    .test(
      'username-length-min',
      errorMessagesRegistration.MIN_LENGTH_LOGIN,
      (value) => !value || value.length >= 5
    )
    .matches(/^[a-zA-Z0-9_-]+$/, errorMessagesRegistration.INCORRECT_LOGIN_FORMAT),
  password: passwordValidationSchema,
  repeatPassword: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .oneOf([Yup.ref('password')], errorMessagesRegistration.PASSWORDS_MUST_MATCH),
  email: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .test('contains-at', errorMessages.MISSING_SYMBOL, (value) => !value || value.includes('@'))
    .email(errorMessages.INVALID_EMAIL_FORMAT)
    .test('blocked-domain', errorMessages.BLOCKED_EMAIL_DOMAIN, function (value) {
      if (!value || !value.includes('@')) return true;
      const domain = value.split('@')[1];
      return !blockedDomains.some(
        (blocked) => domain === blocked || domain?.endsWith(`.${blocked}`)
      );
    })
    .min(1, errorMessages.EMAIL_ADDRESS_REQUIRED)
    .required(errorMessages.FIELD_REQUIRED),
  phone: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .test('phone-validation', errorMessages.INVALID_INPUT_DATA, function (value) {
      if (!value) return false;
      const cleanPhone = value.replace(/[\s\-()]/g, '');
      if (cleanPhone.startsWith('+380')) {
        return /^\+380\d{9}$/.test(cleanPhone);
      } else {
        return /^\+\d{1,3}\d{5}$/.test(cleanPhone);
      }
    }),
});

export const changePasswordValidationSchema = Yup.object().shape({
  newPassword: passwordValidationSchema,
  repeatPassword: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .oneOf([Yup.ref('newPassword')], errorMessagesRegistration.PASSWORDS_MUST_MATCH),
});

export const signInValidationSchema = Yup.object().shape({
  username: Yup.string().required(errorMessages.FIELD_REQUIRED),
  password: Yup.string().required(errorMessages.FIELD_REQUIRED),
});
